module.exports = __webpack_public_path__ + "img/violet_123.471e0195.png";